import styled, { css, keyframes } from 'styled-components';

type StyledInputProps = {
  error?: boolean;
  iconURL?: string;
};

export const Input = styled.input<StyledInputProps>`
  border-radius: ${({ theme }) => theme.BORDER_RADIUS};
  border: 1px solid ${({ error, theme }) => (error ? theme.COLORS.RED : theme.COLORS.PRIMARY_LIGHTER)};
  color: ${({ theme }) => theme.COLORS.PRIMARY};
  height: 50px;
  width: 100%;
  margin-top: 4px;
  background-color: #ffffff;
  background-image: ${({ iconURL }) => (iconURL ? `url(${iconURL})` : 'none')};
  background-size: 20px;
  background-position-x: 10px;
  background-position-y: center;
  background-repeat: no-repeat;
  padding: ${({ iconURL }) => (iconURL ? '10px 10px 10px 40px' : '10px')};

  &:focus {
    outline: ${({ error, theme }) => (error ? theme.COLORS.RED : theme.COLORS.PRIMARY)} auto 1px;
  }

  &::placeholder {
    color: ${({ error, theme }) => (error ? theme.COLORS.RED : theme.COLORS.PRIMARY)};
    opacity: 0.5;
  }
`;

export const InputV2 = styled.input<StyledInputProps>`
  border: none;
  border-radius: 0.4rem 0 0 0.4rem;
  color: white;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.1rem;
  height: 100%;
  width: 100%;
  background-color: rgba(247, 247, 247, 0.2);
  padding: ${({ iconURL }) => (iconURL ? '1rem 1rem 1rem 4rem' : '1rem 1.8rem')};

  &:focus {
    outline: ${({ error, theme }) => (error ? theme.COLORS.RED : theme.COLORS.V2.PRIMARY)} auto 1px;
  }

  &::placeholder {
    color: ${({ error, theme }) => (error ? theme.COLORS.RED : 'white')};
    padding: ${({ iconURL }) => (iconURL ? '1rem 1rem 1rem 4rem' : '1rem')};
  }

  ${({ theme }) => theme.MEDIA.LG} {
    font-weight: 400;
    font-size: 1.8rem;
    line-height: 2.2rem;
    padding: ${({ iconURL }) => (iconURL ? '1rem 1rem 1rem 4rem' : '1.8rem')};
  }
`;

type ButtonWrapperProps = {
  columns?: string;
  justifyContent?: string;
  margin?: string;
};

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  align-items: center;
  display: grid;
  grid-gap: 8px;
  grid-template-columns: ${({ columns }) => `repeat(${columns}, min-content)` || 'min-content'};
  justify-content: ${({ justifyContent }) => justifyContent || 'end'};
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
  white-space: nowrap;
`;

const gradient = keyframes`
  {
    0% {
      background-position: 0 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }
`;

export const AnimatedGradient = css`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  line-height: 110%;
  animation: ${gradient} 5s ease-in-out infinite;
  background: linear-gradient(263.37deg, #fccc51 0.21%, #fd6e40 52.03%, #e75b95 103.85%);
  background-size: 150%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
